import { SortModelItem } from "ag-grid-community";

/**
 * Transforme un modèle de tri AG Grid en clause ORDER BY SQL.
 * @example sortModelToOrderBy([{ colId: "dvclCode", sort: "asc" }, { colId: "dvclDtprevu", sort: "desc" }])
 * // => "dvclCode asc, dvclDtprevu desc"
 */
export function sortModelToOrderBy(sortModel: SortModelItem[]): string {
    return sortModel
      .filter(({ colId }) => colId)
      .map(({ colId, sort }) => `${colId} ${sort ?? "asc"}`)
      .join(", ");
  }
  
  /**
   * Transforme une clause ORDER BY SQL en modèle de tri AG Grid.
   * @example orderByToSortModel("dvclCode asc, dvclDtprevu desc")
   * // => [{ colId: "dvclCode", sort: "asc" }, { colId: "dvclDtprevu", sort: "desc" }]
   */
  export function orderByToSortModel(orderBy: string): SortModelItem[] {
    if (!orderBy.trim()) {
      return [];
    }
  
    return orderBy.split(",").reduce<SortModelItem[]>((sortModel, clause) => {
      const parts = clause.trim().split(/\s+/);
      const colId = parts[0];
      if (!colId) {
        return sortModel;
      }
  
      const direction = (parts[1] ?? "asc").toLowerCase();
      sortModel.push({
        colId,
        sort: direction === "desc" ? "desc" : "asc"
      });
      return sortModel;
    }, []);
  }